// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9777) return "static/chunks/recorder.4d74e3253d2538b8.js";
	if (chunkId === 12) return "static/chunks/profiler.cde8eb583d3276a2.js";
	if (chunkId === 549) return "static/chunks/549.b8886c27a0f42053.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2367":"03862fdca5152521","3497":"e476520a3e8acd95","9081":"bcc813e9c73c8837","9759":"a80d97e5dbca5460","9944":"167eb5a3b288f3b8"}[chunkId] + ".js";
};